import React from "react";
import { Modal } from "../../../components/modals/antd-modals";

const NoteModal = (props) => {
  const { noteModalData, gridState, handleCancel, t } = props;
  const windowWidth = window.innerWidth;

  return (
    <Modal
      type="primary"
      title={t("products.tableList.note")}
      visible={gridState.showNoteModal}
      footer={null}
      onCancel={handleCancel}
      width={windowWidth * 0.5}
    >
      <div className="project-modal">
        <p>{noteModalData}</p>
      </div>
    </Modal>
  );
};

export default NoteModal;
